/* eslint-disable css-modules/no-unused-class */
import React from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import withResponsiveWrapper from '../../../decorators/withResponsiveWrapper';
import Grid from '../../../components/Grid/Grid';
import List from '../../../components/List/List';
import Skeleton from '../../../components/Skeleton/Skeleton';
import BasketItemSkeleton from './BasketItemSkeleton';
import basketStyle from '../Basket.scss';
import s from './BasketSkeleton.scss';

const INPUT_HEIGHT = '38px';

const BasketSkeleton = ({ showServiceMessage, isMobile }) => {
  return (
    <>
      <aside
        className={cx(
          basketStyle.sidebar,
          showServiceMessage && basketStyle['sidebar--showServiceMessage'],
        )}
      >
        <div className={basketStyle.panel}>
          <div className={cx(basketStyle.header, s.header)} />
          <div className={basketStyle.total}>
            <div className={basketStyle.fee}>
              <div className={basketStyle.fee__label}>
                <Skeleton width="150px" height="17px" />
              </div>
              <Skeleton width="40px" height="17px" />
            </div>
            <hr />
            <div className={cx(basketStyle.fee, s.fee)}>
              <div className={basketStyle.fee__label}>
                <Skeleton height="17px" />
              </div>
              <Skeleton width="40px" height="17px" />
            </div>
            <div className={basketStyle.fee}>
              <div className={basketStyle.fee__label}>
                <Skeleton width="120px" height="17px" />
              </div>
              <Skeleton width="40px" height="17px" />
            </div>
            <hr />
            <div className={basketStyle.fee}>
              <div className={basketStyle.fee__label}>
                <Skeleton height="17px" />
              </div>
              <Skeleton width="40px" height="17px" />
            </div>
            <hr />
            <Grid container spacing={16} wrap="wrap" alignItems="center">
              <Grid item xs={24}>
                <div className={s.terms}>
                  <Skeleton width="17px" height="17px" />
                  <Skeleton width="150px" height="17px" />
                </div>
              </Grid>
              <Grid item xs={24}>
                <Skeleton width="100%" height="34px" className={s.button} />
              </Grid>
              <Grid item xs={24}>
                <Skeleton width="100%" height="34px" className={s.button} />
              </Grid>
            </Grid>
          </div>
        </div>
      </aside>

      <div className={cx(basketStyle.main, s.main)}>
        <div className={cx(basketStyle.header, s.header)} />

        <List container>
          <BasketItemSkeleton />
          <BasketItemSkeleton />
        </List>

        <div className={cx(basketStyle.header, s.header)} />

        <div>
          <div className={cx(basketStyle.header, s.header)} />
          <List container component="div" spacing={24} direction="column">
            <List item component="div">
              <div className={basketStyle.panel}>
                <div className={basketStyle.panel__content}>
                  <div className={cx(s.terms, s.fee)}>
                    <Skeleton width="17px" height="17px" className={s.label} />
                    <Skeleton width="250px" height="17px" />
                  </div>
                  <Grid container spacing={16}>
                    <Grid item xs={24}>
                      <div className={s.inputWithLabel}>
                        <Skeleton
                          width="125px"
                          height="20px"
                          className={s.label}
                        />
                        <Skeleton width="100%" height={INPUT_HEIGHT} />
                      </div>
                    </Grid>
                    <Grid item xs={24}>
                      <div className={s.inputWithLabel}>
                        <Skeleton
                          width="125px"
                          height="20px"
                          className={s.label}
                        />
                        <Skeleton
                          width="100%"
                          height={INPUT_HEIGHT}
                          className={s.label}
                        />
                        <Skeleton width="100%" height={INPUT_HEIGHT} />
                      </div>
                    </Grid>
                    <Grid item xs={24}>
                      <div className={s.inputWithLabel}>
                        <Skeleton
                          width="125px"
                          height="20px"
                          className={s.label}
                        />
                        <Skeleton width="100%" height={INPUT_HEIGHT} />
                      </div>
                    </Grid>
                    <Grid item xs={24} md={8}>
                      <div className={s.inputWithLabel}>
                        <Skeleton
                          width="125px"
                          height="20px"
                          className={s.label}
                        />
                        <Skeleton width="100%" height={INPUT_HEIGHT} />
                      </div>
                    </Grid>
                    <Grid item xs={24} md={8}>
                      <div className={s.inputWithLabel}>
                        <Skeleton
                          width="125px"
                          height="20px"
                          className={s.label}
                        />
                        <Skeleton width="100%" height={INPUT_HEIGHT} />
                      </div>
                    </Grid>
                    <Grid item xs={24} md={8}>
                      <div className={s.inputWithLabel}>
                        <Skeleton
                          width="125px"
                          height="20px"
                          className={s.label}
                        />
                        <Skeleton width="100%" height={INPUT_HEIGHT} />
                      </div>
                    </Grid>
                  </Grid>
                </div>
              </div>
            </List>
            <List item component="div">
              <div className={basketStyle.panel}>
                <div className={basketStyle.panel__content}>
                  <div className={s.payments}>
                    <Skeleton width="70px" height="23px" />
                  </div>
                  <Grid container spacing={16}>
                    <Grid item xs={24} md={8}>
                      <Skeleton width="100%" height="53px" />
                    </Grid>
                    <Grid item xs={24} md={8}>
                      <Skeleton width="100%" height="53px" />
                    </Grid>
                    <Grid item xs={24} md={8}>
                      <Skeleton width="100%" height="53px" />
                    </Grid>
                  </Grid>
                </div>
              </div>
            </List>
            <List item component="div">
              <Grid container justify="space-between" spacing={16} wrap="wrap">
                <Grid item xs={24} sm="auto">
                  <Skeleton
                    width={isMobile ? '100%' : '115px'}
                    height="34px"
                    className={s.button}
                  />
                </Grid>
                <Grid item xs={24} sm="auto">
                  <Skeleton
                    width={isMobile ? '100%' : '115px'}
                    height="34px"
                    className={s.button}
                  />
                </Grid>
              </Grid>
            </List>
          </List>
        </div>
      </div>
    </>
  );
};

BasketSkeleton.propTypes = {
  showServiceMessage: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired,
};

export default compose(
  withResponsiveWrapper(),
  withStyles(basketStyle, s),
)(BasketSkeleton);
